import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TalentpoolService } from 'src/app/_services/talentpool.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-shared-talentpools-listing',
    templateUrl: './shared-talentpools-listing.component.html',
    styleUrls: ['./shared-talentpools-listing.component.scss'],
    standalone: false
})
export class SharedTalentpoolsListingComponent implements OnInit {

  constructor(private router : Router , public talentpoolservice : TalentpoolService ,private localstorageservice : LocalStorageService) { }
  talentpoolHeaders = ['Talentpool Name', 'Talent Count', 'Recommended Matches', 'Last Updated', 'Actions'];
  talentpools: any[] = [];
  talentpoolsCount: number = 0;
  start: number = 0;
  end: any;
  talentpoolname: string = '';
  sortby: string = "";
  selectedtalentpools: any = [];
  selectedTalentpools: any = [];
  showSearchLoader:boolean = false;
  selected: boolean = false;
  showLoader: boolean = true;

  @Output() talentpoolEvent: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.talentpoolservice.sharedTalentPoolDetails.subscribe((sharedTalentPoolData) => {
      this.showSearchLoader = false;
      this.talentpools = sharedTalentPoolData ? sharedTalentPoolData.talentpools : [];
      this.talentpoolsCount = sharedTalentPoolData ? sharedTalentPoolData?.count : 0;
    });
    this.getSharedTalentpoolsList();
  }

  /**
   * Get shared talentpools listing (for count)
   */
  getSharedTalentpoolsList() {
    this.showSearchLoader = true;
    // this.showLoader = true;
      this.talentpoolservice.getSharedTalentpoolsList(this.localstorageservice.getItem('usernumber'), this.sortby, this.talentpoolname).subscribe((res:any)=>{
        // this.showSearchLoader = false;
        this.showLoader = false;
        if(res.status === "success") {
          this.talentpools = res?.data?.talentpools || [];
          this.talentpoolsCount = this.talentpools?.length;
          !this.sortby && !this.talentpoolname && this.localstorageservice.setItem('sharedTalentPoolDetails', JSON.stringify(res?.data) || null);
          this.talentpoolservice.setSharedTalentPoolDetails(res?.data || null);
        }
      },
      (_) => {
        this.showSearchLoader = false;
        this.showLoader = false;
        this.talentpools = [];
        this.talentpoolsCount = 0;
        !this.sortby && !this.talentpoolname && this.localstorageservice.setItem('sharedTalentPoolDetails', null);
        this.talentpoolservice.setSharedTalentPoolDetails(null);
      });
  }

  /**
   * search talentpool name
   * @param event
   */
  searchtalentpools(event) {
    let value = event.target.value
    this.talentpoolname = value
    this.getSharedTalentpoolsList()
  }

  /**
   * Sort talentpools listing
   * @param sorttype
   */
  sorttalenpoolList(sorttype: string) {
    this.sortby = sorttype;
    this.getSharedTalentpoolsList();
  }

  /**
   * Redirect to talentpool details view
   * @param type
   */
  OpenCandidateList(type: any){
    if(type == 'all'){
      this.router.navigateByUrl("/candidate-list")
    }
    else{
      let talentpoolid = type.talentpoolid
      this.router.navigate(['talentpool/details/' + talentpoolid]);
    }
  }

  /**
   * Handle select & unselect all operations
   * @param talentpool
   * @param value
   */
  checkIfAllSelected(talentpool: any, value) {
    if (value == true) {
      this.selectedtalentpools.push(talentpool.talentpoolnumber);
      if(this.selectedtalentpools?.length === this.talentpoolsCount) {
        this.selected = true
      }
    } else {
      this.selectedtalentpools = _.without(this.selectedtalentpools, talentpool.talentpoolnumber);
      this.selected = false
    }
  }

}
